import { ref } from 'vue';
import type { RaumplanungAttributeMetadataListEntry } from 'atlas-shared';
import type { IndicatorFilter } from './IndicatorFilter';

/**
 * Filter that keeps only datasets whose label matches a free-text query
 * (case-insensitive substring match on `label` and `label_toc`).
 *
 * Inactive (empty query) returns `true` for every dataset so the list is
 * shown unfiltered.
 */
export class TextFilter implements IndicatorFilter<string> {

    readonly id = "text"

    readonly label = "Textsuche"

    /** The current search query; empty string means the filter is inactive. */
    query = ref("")

    applies(dataset: RaumplanungAttributeMetadataListEntry): boolean {
        const q = this.query.value.trim().toLowerCase()
        if (!q) return true
        return (
            (dataset.label?.toLowerCase().includes(q) ?? false) ||
            (dataset.label_toc?.toLowerCase().includes(q) ?? false)
        )
    }

    /**
     * The text query is never cleared automatically. It is the user's input
     * and must persist across focus changes, unpinning and "Alle Indikatoren".
     * The only way to clear it is the user editing the input field directly.
     */
    reset(): void {
        // Intentionally a no-op: never clear the text field automatically.
    }

    setConfig(config: string): void {
        this.query.value = config
    }
}